const initCatalogGift = {
    catalogGifts: [],
    currentPage: 1,
    totalPage: 1,
    limitPage: 10,
    lengthPage: 1,
    searchValue: "",
    isFormLoading: false,
  };
  
  export const catalogGiftReducer = (state = initCatalogGift, action: any) => {
    if (action.type === "SET_CATALOG_GIFT") {
      return {
        ...state,
        catalogGifts: action.value,
      };
    }
    if (action.type === "SET_CATALOG_GIFT_CURRENT_PAGE") {
        return {
          ...state,
          currentPage: action.currentPage,
        };
      }
      if (action.type === "SET_CATALOG_GIFT_PAGE") {
        return {
          ...state,
          totalPage: action.totalPage,
          limitPage: action.limitPage,
          lengthPage: action.lengthPage,
        };
      }
      if (action.type === "SET_SEARCH_CATALOG_GIFT") {
        return {
          ...state,
          searchValue: action.searchValue,
        };
      }
    if (action.type === "SET_FORM_LOADING") {
      return {
        ...state,
        isFormLoading: action.value,
      };
    }
    return state;
  };
  